var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportLeakage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2847 3.5H8.82469L3.55469 8.77V16.23L8.82469 21.5H16.2847L21.5547 16.23V8.77L16.2847 3.5ZM19.5547 15.4L15.4547 19.5H9.65469L5.55469 15.4V9.6L9.65469 5.5H15.4547L19.5547 9.6V15.4Z",
    fill: "#212121"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5547 17.5C13.107 17.5 13.5547 17.0523 13.5547 16.5C13.5547 15.9477 13.107 15.5 12.5547 15.5C12.0024 15.5 11.5547 15.9477 11.5547 16.5C11.5547 17.0523 12.0024 17.5 12.5547 17.5Z",
    fill: "#212121"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5547 7.5H13.5547V14.5H11.5547V7.5Z",
    fill: "#212121"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportLeakage);
export default __webpack_public_path__ + "static/media/reportLeakage.21f014464388cc4e0dd33d8a2646ca1e.svg";
export { ForwardRef as ReactComponent };